import styled from 'styled-components'

export const Grid = styled.div`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  margin-top: 64px;
`
